export default {
  /**
   * Marks the core page load as complete.
   *
   * @param {function} commit
   * @return {Promise}
   */
  endCorePageLoad({ commit }) {
    return commit('setCorePageLoadComplete', true)
  },

  /**
   * Marks the mobile menu as open.
   *
   * @param {function} commit
   * @return {Promise}
   */
  openMobileMenu({ commit }) {
    return commit('setMobileMenuOpen', true)
  },

  /**
   * Marks the mobile menu as closed.
   *
   * @param {function} commit
   * @return {Promise}
   */
  closeMobileMenu({ commit }) {
    return commit('setMobileMenuOpen', false)
  },

  /**
   * Marks the floating footer as visible.
   *
   * @param {Function} commit
   */
  displayFloatingFooter({ commit }) {
    return commit('setFloatingFooterVisible', true)
  },

  /**
   * Marks the floating footer as hidden.
   *
   * @param {Function} commit
   */
  hideFloatingFooter({ commit }) {
    return commit('setFloatingFooterVisible', false)
  },
}
